import type { ReactNode } from "react";

export type StatTone = "neutral" | "revenue" | "cost" | "positive" | "critical";

const TONE_COLORS: Record<StatTone, string | undefined> = {
  neutral: undefined,
  revenue: "var(--roi-revenue)",
  cost: "var(--roi-cost)",
  positive: "var(--chart-ok)",
  critical: "var(--chart-crit)",
};

interface StatTileProps {
  label: string;
  /** Already formatted. Formatting is the caller's job — see src/shared/roi/format.ts. */
  value: ReactNode;
  hint?: ReactNode;
  tone?: StatTone;
}

/**
 * One figure with its name. The `tabular` class is not decoration: without it a
 * changing figure re-widths its own column and the whole strip jitters.
 */
export function StatTile({ label, value, hint, tone = "neutral" }: StatTileProps) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5 rounded-lg border border-line bg-chip-bg px-3 py-2">
      <span className="text-xs font-semibold uppercase tracking-wider text-ink-soft">{label}</span>
      <span
        className="tabular truncate text-xl font-bold text-ink"
        style={TONE_COLORS[tone] ? { color: TONE_COLORS[tone] } : undefined}
      >
        {value}
      </span>
      {hint && <span className="truncate text-xs text-ink-soft">{hint}</span>}
    </div>
  );
}
